import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { initMetaPixel } from './utils/metaPixel';
import { StoryHook } from './components/StoryHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedAttempts } from './components/FailedAttempts';
import { ProtocoloHielo } from './components/ProtocoloHielo';
import { WhatYoullAchieve } from './components/WhatYoullAchieve';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream-100 font-sans text-charcoal selection:bg-sage-200 selection:text-charcoal" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <StoryHook data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedAttempts data-id="element-5" />
        <ProtocoloHielo data-id="element-6" />
        <WhatYoullAchieve data-id="element-7" />
        <WhoIsItFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <SocialProof data-id="element-10" />
        <OfferSection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}